import {createContext} from "react";
import {Route} from "../routes";

export const RouteContext = createContext<{route?: Route}>({
    route: undefined
});
